// extracted by mini-css-extract-plugin
export default {"header":"IpaCsWImJ0","question":"m2mMx47Cc5","answerContent":"UaIxrrLHUU","answerText":"PcaDo0nlui","answerText_disabled":"yR0mTmm6kw","placeholder":"EG6cDGpGb9"};